import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../../rootSelectors';
import VocabTQVMView from '../../VocabTQVMView';
import { onResponseSelect } from '../../../vocabActions';
import { fetchVocabTQVMContent } from '../../vocabTQVMActions';
import { stopAudio, narrateReset } from '../../../../common/audio/audioActions';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';
import { narrateStimulus, resetSelectedIndex } from '../../../../common/questions/questionsActions';
import { unmountScreen } from '../../../../common/screen/screenActions';
import { narratePracticeScreen, onNextPracticeButtonClick } from './VocabTQVMPracticeActions';
import { VOCAB_AUDIO_INSTRUCTIONS } from '../../../vocabConstants';
import { PRACTICE } from '../../../../constants/assessmentItemType';
import { getAvatarPosition } from '../../../../common/alex/AlexUtils';

const mapStateToProps = state => ({
    isDataFetched: selectors.getIsVocabTQVMDataFetched(state),
    stimulus: selectors.getVocabTQVMStimulusInfo(state, PRACTICE),
    possibleResponses: selectors.getVocabTQVMPossibleResponses(state, PRACTICE),
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isScreenGreyedOut: selectors.getIsScreenGreyedOut(state),
    isStimulusPlaying: selectors.getIsStimulusPlaying(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    selectedResponse: selectors.getSelectedIndex(state),
});

const mapDispatchToProps = dispatch => ({
    fetchContent: () => {
        dispatch(fetchVocabTQVMContent());
    },
    narrateScreen: stimulusAudio => dispatch(narratePracticeScreen(stimulusAudio)),
    playStimulus: stimulusAudio => dispatch(narrateStimulus(stimulusAudio)),
    selectResponse: response => dispatch(onResponseSelect(response)),
    onNext: () => dispatch(onNextPracticeButtonClick()),
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(resetSelectedIndex());
        dispatch(unmountScreen());
    },
});

const avatarMapStateToProps = state => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.MIDDLE_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
        instructions:
            VOCAB_AUDIO_INSTRUCTIONS[selectors.getCurrentLanguage(state)]
                .vocabTQVMPracticeInstructionStart,
    };
};

const VocabTQVMPracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(VocabTQVMView);

export default VocabTQVMPracticeContainer;
